export default "/images/vendor/flag-icon-css/flags/4x3/sn.svg?1ce79520b54b680dcc8ef40e1ed8a80b";